import type { SanityProduct } from '@repo/models/gatsby-graphql-types';

const findCompareAtPriceRangeCad = (sanityProduct: SanityProduct) => {
  const sanityVariants = sanityProduct?.store?.variants;

  let min = sanityVariants?.[0]?.canadaStore?.compareAtPrice || 0;
  let max = sanityVariants?.[0]?.canadaStore?.compareAtPrice || 0;

  sanityVariants?.forEach(shopifyVariant => {
    if (min > 0 && min > shopifyVariant?.canadaStore?.compareAtPrice) {
      min = shopifyVariant?.canadaStore?.compareAtPrice;
    }

    if (max > 0 && max < shopifyVariant?.canadaStore?.compareAtPrice) {
      max = shopifyVariant?.canadaStore?.compareAtPrice;
    }
  });

  return {
    minVariantPrice: {
      amount: min,
      currencyCode: 'CAD',
    },
    maxVariantPrice: {
      amount: max,
      currencyCode: 'CAD',
    },
  };
};

const findMinMaxVariantPriceCad = (sanityProduct: SanityProduct) => {
  const sanityVariants = sanityProduct?.store?.variants;

  let min = sanityVariants?.[0]?.canadaStore?.price || 0;
  let max = sanityVariants?.[0]?.canadaStore?.price || 0;

  sanityVariants?.forEach(shopifyVariant => {
    if (min > 0 && min > shopifyVariant?.canadaStore?.price) {
      min = shopifyVariant?.canadaStore?.price;
    }

    if (max > 0 && max < shopifyVariant?.canadaStore?.price) {
      max = shopifyVariant?.canadaStore?.price;
    }
  });

  return {
    minVariantPrice: {
      amount: min,
      currencyCode: 'CAD',
    },
    maxVariantPrice: {
      amount: max,
      currencyCode: 'CAD',
    },
  };
};

export { findCompareAtPriceRangeCad, findMinMaxVariantPriceCad };
